import { Box } from "@jewlr/storybook/core"

import { jewlr_t } from "helpers/application"

let getimagePath = () =>
  `${sl.config.jewlr_asset_url}images/product/stones/100px/1x/side/`

export const birthStones = () => {
  let imagePath = getimagePath()
  return [
    {
      dscr: (
        <>
          Passion, Vitality,
          <Box as="br" display={{ tablet: "none" }} /> Good Luck
        </>
      ),
      month: "January",
      photo: `${imagePath}01GARN_RD.png`,
      text: "Garnet",
    },
    {
      dscr: (
        <>
          Clarity, Wisdom,
          <Box as="br" display={{ tablet: "none" }} /> Intuition
        </>
      ),
      month: "February",
      photo: `${imagePath}02AMTH_RD.png`,
      text: "Amethyst",
    },
    {
      dscr: (
        <>
          Courage,
          <Box as="br" display={{ tablet: "none" }} /> Protection, Insight
        </>
      ),
      month: "March",
      photo: `${imagePath}03AQUA_RD.png`,
      text: "Aquamarine",
    },
    {
      dscr: (
        <>
          Eternity, Strength,
          <Box as="br" display={{ tablet: "none" }} /> Protection
        </>
      ),
      month: "April",
      photo: `${imagePath}04DIAM_RD.png`,
      text: "Diamond",
    },
    {
      dscr: (
        <>
          Strength, Clarity,
          <Box as="br" display={{ tablet: "none" }} /> Confidence
        </>
      ),
      month: "April",
      photo: `${imagePath}04WTPZ_RD.png`,
      text: "White Topaz",
    },
    {
      dscr: (
        <>
          Peace, Balance,
          <Box as="br" display={{ tablet: "none" }} /> Reason
        </>
      ),
      month: "May",
      photo: `${imagePath}05EMER_RD.png`,
      text: "Emerald",
    },
    {
      dscr: (
        <>
          Endurance, Serenity,
          <Box as="br" display={{ tablet: "none" }} /> Enlightenment
        </>
      ),
      month: "June",
      photo: `${imagePath}06SQTZ_RD.png`,
      text: "Smokey Quartz",
    },
    {
      dscr: (
        <>
          Friendship, Love,
          <Box as="br" display={{ tablet: "none" }} /> Passion
        </>
      ),
      month: "July",
      photo: `${imagePath}07RUBY_RD.png`,
      text: "Ruby",
    },
    {
      dscr: (
        <>
          Strength, Prosperity,
          <Box as="br" display={{ tablet: "none" }} /> Growth
        </>
      ),
      month: "August",
      photo: `${imagePath}08PERI_RD.png`,
      text: "Peridot",
    },
    {
      dscr: (
        <>
          Peace, Happiness,
          <Box as="br" display={{ tablet: "none" }} /> Insight
        </>
      ),
      month: "September",
      photo: `${imagePath}09BSAP_RD.png`,
      text: "Blue Sapphire",
    },
    {
      dscr: (
        <>
          Imagination, Love,
          <Box as="br" display={{ tablet: "none" }} /> Spontaneity
        </>
      ),
      month: "October",
      photo: `${imagePath}10OPAL_RD.png`,
      text: "Opal",
    },
    {
      dscr: (
        <>
          Inspiration, Balance,
          <Box as="br" display={{ tablet: "none" }} /> Confidence
        </>
      ),
      month: (
        <>
          <Box as="br" display={{ tablet: "none" }} />
          October
        </>
      ),
      photo: `${imagePath}10PTOU_RD.png`,
      text: "Pink Tourmaline",
    },
    {
      dscr: (
        <>
          Optimism, Endurance,
          <Box as="br" display={{ tablet: "none" }} /> Generosity
        </>
      ),
      month: (
        <>
          <Box as="br" display={{ tablet: "none" }} />
          November
        </>
      ),
      photo: `${imagePath}11CITR_RD.png`,
      text: "Citrine",
    },
    {
      dscr: (
        <>
          Strength, Confidence,
          <Box as="br" display={{ tablet: "none" }} /> Clarity
        </>
      ),
      month: (
        <>
          <Box as="br" display={{ tablet: "none" }} />
          December
        </>
      ),
      photo: `${imagePath}12BTPZ_RD.png`,
      text: "Blue Topaz",
    },
  ]
}

export const gemStones = () => {
  let imagePath = getimagePath()
  return [
    {
      alt: "Yellow Sapphire",
      photo: `${imagePath}YSAP_RD.png`,
      text: (
        <>
          Yellow <Box as="br" />
          Sapphire
        </>
      ),
    },
    {
      alt: "Orange Sapphire",
      photo: `${imagePath}OSAP_RD.png`,
      text: (
        <>
          Orange <Box as="br" />
          Sapphire
        </>
      ),
    },
    {
      alt: "Pink Sapphire",
      photo: `${imagePath}PSAP_RD.png`,
      text: (
        <>
          Pink <Box as="br" />
          Sapphire
        </>
      ),
    },
    {
      alt: "Green Sapphire",
      photo: `${imagePath}GSAP_RD.png`,
      text: (
        <>
          Green <Box as="br" />
          Sapphire
        </>
      ),
    },
    {
      alt: "Black Diamond",
      photo: `${imagePath}04BDIA_RD.png`,
      text: (
        <>
          Black <Box as="br" />
          Diamond
        </>
      ),
    },
  ]
}

export const simulated = () => {
  let imagePath = getimagePath()
  return [
    {
      month: "January",
      photo: `${imagePath}01GARN_RD.png`,
      text: "Garnet",
    },
    {
      month: "February",
      photo: `${imagePath}02AMTH_RD.png`,
      text: "Amethyst",
    },
    {
      month: "March",
      photo: `${imagePath}03AQUA_RD.png`,
      text: "Aquamarine",
    },
    {
      month: "April",
      photo: `${imagePath}04CZIR_RD.png`,
      text: "Cubic Zirconia",
    },
    {
      month: "May",
      photo: `${imagePath}05EMER_RD.png`,
      text: "Emerald",
    },
    {
      month: "June",
      photo: `${imagePath}06SQTZ_RD.png`,
      text: "Smokey Quartz",
    },
    {
      month: "June",
      photo: `${imagePath}S06ALEX_RD.png`,
      text: "Alexandrite",
    },
    {
      month: "July",
      photo: `${imagePath}07RUBY_RD.png`,
      text: "Ruby",
    },
    {
      month: "August",
      photo: `${imagePath}08PERI_RD.png`,
      text: "Peridot",
    },
    {
      month: "September",
      photo: `${imagePath}09BSAP_RD.png`,
      text: "Sapphire",
    },
    {
      month: "October",
      photo: `${imagePath}10OPAL_RD.png`,
      text: "Opal",
    },
    {
      month: "October",
      photo: `${imagePath}10PTOU_RD.png`,
      text: "Pink Tourmaline",
    },
    {
      month: "November",
      photo: `${imagePath}11CITR_RD.png`,
      text: "Citrine",
    },
    {
      month: "December",
      photo: `${imagePath}12BTPZ_RD.png`,
      text: "Blue Topaz",
    },
  ]
}

export const zirconiaStones = () => {
  let imagePath = getimagePath()
  return [
    {
      alt: "White Premium Zirconia",
      photo: `${imagePath}SWKWhite_RD.png`,
      text: (
        <>
          White <Box as="br" />
          Premium <Box as="br" />
          Zirconia
        </>
      ),
    },
    {
      alt: "Golden Yellow Premium Zirconia",
      photo: `${imagePath}SWKGoldenYellow_RD.png`,
      text: (
        <>
          Golden Yellow <Box as="br" />
          Premium <Box as="br" />
          Zirconia
        </>
      ),
    },
    {
      alt: "Lavender Premium Zirconia",
      photo: `${imagePath}SWKLavender_RD.png`,
      text: (
        <>
          Lavender <Box as="br" />
          Premium <Box as="br" />
          Zirconia
        </>
      ),
    },
    {
      alt: "Mint Premium Zirconia",
      photo: `${imagePath}SWKMint_RD.png`,
      text: (
        <>
          Mint <Box as="br" />
          Premium <Box as="br" />
          Zirconia
        </>
      ),
    },
    {
      alt: "Fancy Yellow Premium Zirconia",
      photo: `${imagePath}SWKFancyYellow_RD.png`,
      text: (
        <>
          Fancy Yellow <Box as="br" />
          Premium <Box as="br" />
          Zirconia
        </>
      ),
    },
    {
      alt: "Fancy Brown Premium Zirconia",
      photo: `${imagePath}SWKFancyBrown_RD.png`,
      text: (
        <>
          Fancy Brown <Box as="br" />
          Premium <Box as="br" />
          Zirconia
        </>
      ),
    },
    {
      alt: "Black Premium Zirconia",
      photo: `${imagePath}04BDIA_RD.png`,
      text: (
        <>
          Black <Box as="br" />
          Premium <Box as="br" />
          Zirconia
        </>
      ),
    },
    {
      alt: "Red Premium Zirconia",
      photo: `${imagePath}SWKRed_RD.png`,
      text: (
        <>
          Red <Box as="br" />
          Premium <Box as="br" /> Zirconia
        </>
      ),
    },
    {
      alt: "Green Premium Zirconia",
      photo: `${imagePath}SWKGreen_RD.png`,
      text: (
        <>
          Green <Box as="br" />
          Premium <Box as="br" />
          Zirconia
        </>
      ),
    },
    {
      alt: "Fancy Pink Premium Zirconia",
      photo: `${imagePath}SWKFancyPink_RD.png`,
      text: (
        <>
          Fancy Pink <Box as="br" />
          Premium <Box as="br" />
          Zirconia
        </>
      ),
    },
    {
      alt: "Fancy Blue Premium Zirconia",
      photo: `${imagePath}SWKFancyBlue_RD.png `,
      text: (
        <>
          Fancy Blue <Box as="br" />
          Premium <Box as="br" />
          Zirconia
        </>
      ),
    },
  ]
}

export const ctaFirst = () => [
  {
    btn: "Shop All Gemstones",
    image: "gemstones/JWL0013",
    link: `/birthstone-${jewlr_t("terms.jewelry")}`,
    textPosition: "50%",
    title: "Shop For Your Birthstone",
  },
]

export const ctaSecond = () => [
  {
    btn: "Shop All Gemstones",
    image: "gemstones/JWL0246",
    link: `/birthstone-${jewlr_t("terms.jewelry")}`,
    textPosition: "20%",
    title: "Shop For Your Birthstone",
  },
]
